export class SessionType {
    public id: string;
    public name: string;
}

export const sessionTypeOptions: SessionType[] = [
    { id: 'accelerator', name: $localize`Aceleradora` },
    { id: 'room', name: $localize`Habitación` },
    { id: 'online', name: $localize`Online` },
    { id: 'self_guided', name: $localize`Autónomo` },
];